import { Box, Stack, Typography } from '@mui/material'
import { ReactNode } from 'react'
import { BackArrowIcon } from 'components/icons'
import { Button } from '../../components'
import { useNavigate } from 'react-router-dom'

const headerContainer = {
  backgroundColor: '#f7f7f7',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  px: '40px',
  height: 74,
  boxShadow:
    '0px 4px 6px rgba(0, 0, 0, 0.05), 0px 1px 3px rgba(238, 237, 237, 0.05)',
}

const headerTitleSection = {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
  flex: 1,
}

type HeaderTypes = {
  sidebarOpen?: boolean
  toggleSidebar?: () => void
  title?: string | ReactNode
  actionButton?: ReactNode
  showGoBack?: boolean
  goBackUrl?: string
}

export const Header = ({
  title,
  actionButton,
  showGoBack,
  goBackUrl,
}: HeaderTypes) => {
  const navigate = useNavigate()

  const handleGoBack = () => {
    if (goBackUrl) {
      navigate(goBackUrl)
    } else {
      navigate(-1)
    }
  }

  return (
    <Box sx={headerContainer}>
      <Stack sx={headerTitleSection}>
        {showGoBack && (
          <Button
            startIcon={<BackArrowIcon size={24} />}
            onClick={handleGoBack}
            variantType="text"
          >
            Back
          </Button>
        )}
        {typeof title === 'string' ? (
          <Typography fontWeight="700" fontSize={20} flex={1}>
            {title}
          </Typography>
        ) : (
          title
        )}
      </Stack>
      {actionButton && (
        <Stack
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
        >
          {actionButton}
        </Stack>
      )}
    </Box>
  )
}
